<div id="leftButtons" class="flex items-center">

    @if(!isMobile()){
        <app-back-button/>
        <app-home-button/>
    }

</div>